// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__3LQHZ","additionalInfo":"AgreementModal_additionalInfo__j5e23"};